var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sb-footer "}},[_c('div',{staticClass:"gray-550 f-90 d-flex flex-column flex-sm-row justify-content-between footer mb-3"},[_c('div',{staticClass:"text-white mr-2"},[_vm._v("powered by")]),_c('a',{staticStyle:{"color":"#c883ff"},attrs:{"href":"https://qesg.co.kr/"}},[_vm._v("ESG Reporting Tool")])])])
}]

export { render, staticRenderFns }